const funcion3 = {
    titulo: `Función: parámetros de tipo Array`,
    problemas: [
      {
        codigo:1,
        descripcion: `Una función puede tener parámetros no solo de tipo number, string y boolean sino también de tipo Array.
La particularidad que cuando pasamos un arreglo como parámetro, si en la función modificamos las componentes del parámetro luego el arreglo que se ha pasado se modifica también (recordemos que esto no sucede con parámetros de tipo number, string y boolean)`,
programa: `function cargar(arreglo) {
  for (let i = 0; i < arreglo.length; i++) {
    arreglo[i] = i
  }
}

const arreglo = [0, 0, 0, 0, 0]
cargar(arreglo)
console.log(arreglo)
`,
        solucion: "[0, 1, 2, 3, 4]"
      },{
        codigo:2,
        descripcion: ``,
programa: `function cargar(arreglo) {
  arreglo.fill(10)
}

function imprimir(arreglo) {
  console.log(arreglo)
}

const arreglo = new Array(5).fill(0)
cargar(arreglo)
imprimir(arreglo)
`,
        solucion: "[10, 10, 10, 10, 10]"
      },{
        codigo:3,
        descripcion: ``,
programa: `function cargar(arreglo) {
  arreglo[0] = 10
  arreglo[1] = 80
  arreglo[2] = 2000
  arreglo[3] = 700
  arreglo[4] = 110
}

function orderar(arreglo) {
  arreglo.sort((a, b) => a - b)
}

function imprimir(arreglo) {
  console.log(arreglo)
}

const arreglo = new Array(5)
cargar(arreglo)
orderar(arreglo)
imprimir(arreglo)
`,
        solucion: "[10, 80, 110, 700, 2000]"
      },{
        codigo:4,
        descripcion: ``,
programa: `function cargar(arreglo) {
  arreglo[0] = 10
  arreglo[1] = 80
  arreglo[2] = 2000
  arreglo[3] = 700
  arreglo[4] = 110
}

function mayor(arreglo) {
  let mayor = arreglo[0]
  for (let i = 1; i < arreglo.length; i++) {
    if (arreglo[i] > mayor) {
      mayor = arreglo[i]
    }
  }
  console.log(mayor)
}

const arreglo = new Array(5)
cargar(arreglo)
mayor(arreglo)
`,
        solucion: "2000"
      },{
        codigo:5,
        descripcion: `Si no pasamos un arreglo, luego el parámetro tiene el valor undefined y se genera un error cuando tratamos de acceder a un subíndice de undefined`,
programa: `function cargar(arreglo) {
  arreglo[0] = 10
  arreglo[1] = 80
  arreglo[2] = 2000
  arreglo[3] = 700
  arreglo[4] = 110
}

const arreglo = new Array(5)
cargar()
`,
        solucion: "error"
      },{
        codigo:6,
        descripcion: `Algo muy importante es que dentro de la función podemos cambiar las componentes del arreglo, pero no podemos cambiar la referencia del parámetro a otro arreglo.`,
programa: `function intentarCambiar(arreglo) {
  const arreglo2 = new Array(5).fill(1)
  arreglo = arreglo2
}


const arreglo = new Array(5).fill(10)
intentarCambiar(arreglo)
console.log(arreglo)
`,
        solucion: "[10, 10, 10, 10, 10]"
      }
    ]
  }

export default funcion3;